import { render } from "./NothernSkies.vue?vue&type=template&id=5fe74270&scoped=true"
import script from "./NothernSkies.vue?vue&type=script&lang=js"
export * from "./NothernSkies.vue?vue&type=script&lang=js"

import "./NothernSkies.vue?vue&type=style&index=0&id=5fe74270&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fe74270"]])

export default __exports__